import React from 'react';
import { cx } from 'helpers';


const BottomRightCornerFrame = ({ className, style = {}, children }) => (
  <div
    style={style}
    className={cx(className, "fixed bottom-0 right-0")}
  >
    {children}
  </div>
);


export {
  BottomRightCornerFrame,
};



// WEBPACK FOOTER //
// ./src/components/misc/fixedFrames.js